import * as analytics from "@/modules/analytics";
import { valueNames } from "@/modules/Constants";
import type ShopWindowConfig from "@/plugin/ShopWindowConfig";
import { experienceStore, updateTemplateData } from "@/stores/experience/store";
import type { ExperienceTemplate } from "@/stores/experience/types";

interface ApplicationValuePayload {
  region: string;
  key: string;
  value: unknown;
}

export function setApplicationValue(
  region: string,
  key: string,
  value: unknown,
) {
  return experienceStore.dispatch(
    { region: region, key: key, value: value },
    (state, data: ApplicationValuePayload) => {
      state.applicationData.setValue(data.key, data.value);

      if (data.key === valueNames.SHOP_WINDOW_CONFIG) {
        const shopWindow = data.value as ShopWindowConfig;
        analytics.track("Set Shop Window", {
          pix_offset: state.experienceData.nowTime,
          pix_appregion: data.region,
          pix_sw: shopWindow.name,
          pix_cluster: shopWindow.clusterName,
        });
      }
    },
  );
}

export function updateTemplate(template: ExperienceTemplate) {
  return experienceStore.dispatch(template, (state, next) => {
    state.template = next;
    updateTemplateData(state);
  });
}

/** Notifies listeners so the layout re-measures. */
export function resize() {
  return experienceStore.dispatch(true, () => true);
}
